import { render, staticRenderFns } from "./SimilarAttractions.vue?vue&type=template&id=25e1bfae&scoped=true&"
import script from "./SimilarAttractions.vue?vue&type=script&lang=js&"
export * from "./SimilarAttractions.vue?vue&type=script&lang=js&"
import style0 from "./SimilarAttractions.vue?vue&type=style&index=0&id=25e1bfae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e1bfae",
  null
  
)

export default component.exports